import { useContext } from "react";
import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "../context/auth";

/**
 * Niveles de usuario:
 * 1 = Administrador
 * 3 = Operario
 */

/**
 * Tipos de rutas:
 * - 'global': Rutas públicas sin restricción
 * - 'public': Rutas públicas que redirigen a dashboard si el usuario está logueado
 * - 'private': Rutas privadas que requieren autenticación y pueden requerir permisos específicos
 */

const GuardRoute = ({ type, path, component }) => {
    const { usuario } = useContext(AuthContext);
    const { window } = useParams();

    const kickLogin = <Navigate to="/login" replace />;
    const kickDashboard = <Navigate to="/dashboard" replace />;

    if (type === 'global') {
        return component;
    }

    if (type === 'public') {
        if (usuario !== false && usuario !== null) {
            switch (window) {
                case "1": {
                    return <Navigate to="/dengue/nuevo" replace />;
                }
                default:
                    return kickDashboard;
            }
        }
        return component;
    }

    if (type === 'private') {
        if (usuario === null) {
            return kickLogin;
        }

        if (usuario === false) {
            return component;
        }

        const permissionCheck = checkRoutePermissions(path, usuario);
        if (permissionCheck !== null) {
            return permissionCheck;
        }
    }

    return component;
};

const isAdminUser = (usuario) =>
    usuario?.es_admin === true || usuario?.nivel_usuario === 1 || usuario?.sup_usuarios === true;

const esPublico = (usuario) => usuario?.establecimiento?.tipo === 'publico';

/**
 * @param {string} path
 * @param {object} usuario
 * @returns {JSX.Element|null}
 */
const checkRoutePermissions = (path, usuario) => {
    const kickDashboard = <Navigate to="/dashboard" replace />;
    const admin = isAdminUser(usuario);
    const publico = esPublico(usuario);

    // Usuarios: solo admin / supervisión
    if (path.includes("/usuario")) {
        if (!admin) return kickDashboard;
    }

    // Prácticas y establecimientos: solo admin
    if (path.includes("/practica") || path.includes("/establecimiento")) {
        if (!admin) return kickDashboard;
    }

    // Auditoría: solo admin
    if (path.includes("/auditoria")) {
        if (!(usuario?.es_admin === true || usuario?.nivel_usuario === 1)) {
            return kickDashboard;
        }
    }

    // Pacientes: admin o operario de establecimiento público
    if (path.includes("/paciente")) {
        if (!admin && !publico) return kickDashboard;
    }

    // Órdenes: todos los autenticados (admin, público, privado)
    // Alta de orden: requiere puede_cargar_ordenes o admin
    if (path.includes("/orden-practica/nueva")) {
        const puede = usuario?.puede_cargar_ordenes === true || admin;
        if (!puede) return kickDashboard;
    }

    return null;
};

export default GuardRoute;
